import type { ForexUnderlying } from 'models/underlying/forex';
import { FC } from 'react';

export interface ForexTooltipOwnProps {
  hasCutOff?: boolean;
  underlying: ForexUnderlying;
}
export const Forex: FC<ForexTooltipOwnProps> = ({ hasCutOff, underlying }) => (
  <>
    {hasCutOff && (
      <>
        <dt>Cut off:</dt>
        {underlying.cutOff ? <dd>{underlying.cutOff}</dd> : <dd>&nbsp;</dd>}
      </>
    )}
  </>
);
